import { CSSProperties } from '@material-ui/core/styles/withStyles';
import React from 'react';

interface IProps {
  color?: string;
  width?: number;
  height?: number;
  style?: CSSProperties;
}

const AudiobookIcon = ({ color, width = 17, height = 13, style }: IProps) => (
  <svg
    style={{ ...style }}
    width={width}
    height={height}
    viewBox={`0 0 17 13`}
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio={width !== 17 && height !== 13 ? 'none' : 'xMidYMid meet'}
  >
    <g fill={color || '#000'} fillRule="evenodd">
      <path d="M3.25 5.695v4.786a.5.5 0 0 1-.543.497C.902 10.823 0 9.86 0 8.088c0-1.771.902-2.734 2.707-2.89a.5.5 0 0 1 .543.497zM9.75 5.695v4.786a.5.5 0 0 0 .543.497C12.098 10.823 13 9.86 13 8.088c0-1.771-.902-2.734-2.707-2.89a.5.5 0 0 0-.543.497z" />
      <path d="M1.314 5.824C1.124 1.94 2.834 0 6.44 0c3.607 0 5.359 1.941 5.256 5.824h-.807C10.938 2.414 9.455.709 6.44.709c-3.014 0-4.414 1.705-4.198 5.115h-.928z" />
    </g>
  </svg>
);

export default AudiobookIcon;
